import { render, staticRenderFns } from "./LeprosyResultPanel.vue?vue&type=template&id=6dbc88aa&scoped=true"
import script from "./LeprosyResultPanel.vue?vue&type=script&lang=js"
export * from "./LeprosyResultPanel.vue?vue&type=script&lang=js"
import style0 from "./LeprosyResultPanel.vue?vue&type=style&index=0&id=6dbc88aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc88aa",
  null
  
)

export default component.exports